import 'localforage'; // Workaround to make type LocalForage available in generated d.ts file
import * as localforage from 'localforage';
import { AppInstance, ActivityLog } from '../models/app';
import { APP_INSTANCE_KEY } from '../constants';

import { Inject, APP_ID, PLATFORM_ID, Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AppDB {

  appInstance: LocalForage;
  activityLogs: LocalForage;
  appStorage: LocalForage;

  constructor(
    @Inject(APP_ID) appId: string,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    
    if (isPlatformBrowser(platformId)) {
      const name = `_${appId}_app___db_v2`;
      this.appInstance = localforage.createInstance({
        storeName: 'appInstance',
        name,
      });
      this.activityLogs = localforage.createInstance({ 
        storeName: 'activityLogs',
        name,
      });
      this.appStorage = localforage.createInstance({
        storeName: 'appStorage',
        name,
      });
    }

  }

  logActivity(activity: ActivityLog) {
    activity.timestamp = Date.now();
    this.activityLogs.setItem(APP_INSTANCE_KEY, activity);
  }

}
